import axios from 'axios';
import FileSaver from 'file-saver';
import moment from 'moment';
import 'moment/locale/it';
import { IFile } from '../interfaces';

export type SaveFileResult =
    | { ok: true }
    | { ok: false; reason: 'NoFile' | 'MissingFileName' | 'MissingContent' | 'InvalidBase64' | 'SaveFailed'; message: string };


export default class Utilities {


    static decodeHtml(value: string) {
        var elem = document.createElement("div");
        if (!value) { return ''; }

        elem.innerHTML = value.replace(/</g, "&lt;");
        // innerText depends on styling as it doesn't display hidden elements.
        // Therefore, it's better to use textContent not to cause unnecessary reflows.
        return elem.textContent;
    }

    static TryParseToBoolean(input: string): boolean | undefined {
        try {
            return JSON.parse(input);
        }
        catch (e) {
            return undefined;
        }
    }

    //riscrivi lo stesso metodo in c# per il server
    static TryParseToNumber(input: any): number | undefined {
        if (typeof input == 'number') {
            return input;
        }

        const inputString = input ? input.toString() : "";

        // Rimuovi spazi bianchi e caratteri speciali dalla stringa
        const cleanedInput = inputString.replace(/\s/g, '');

        // Sostituisci ',' con '.' per gestire entrambi i separatori decimali
        const normalizedInput = cleanedInput.replace(',', '.');

        // Verifica se la stringa è un numero intero positivo o negativo
        if (/^-?\d+$/.test(normalizedInput)) {
            return parseInt(normalizedInput, 10);
        }

        // Verifica se la stringa è un numero decimale positivo o negativo
        if (/^-?\d+\.\d+$/.test(normalizedInput)) {
            return parseFloat(normalizedInput);
        }

        // Altri formati possono essere gestiti aggiungendo ulteriori condizioni

        // Se la stringa non corrisponde a nessun formato, restituisci undefined
        return undefined;

        //// Esempio di utilizzo:
        //const input1 = "123";
        //const input2 = "-45.67";
        //const input3 = "12,345.67";
        //const input4 = "abc123"; // Formato non valido

        //console.log(convertStringToNumber(input1)); // Output: 123
        //console.log(convertStringToNumber(input2)); // Output: -45.67
        //console.log(convertStringToNumber(input3)); // Output: 12345.67
        //console.log(convertStringToNumber(input4)); // Output: null

    }
    static FormatDate(date: Date, dateOnly: boolean): string {
        var result = "-";
        if (date) {
            try {

                moment.locale('it');
                var dateObjectd = moment(date)
                if (dateOnly)
                    result = dateObjectd.format('L');
                else
                    result = dateObjectd.format('LLL');

                // Esempi formattazione
                // moment.locale();         // it
                // moment().format('LT');   // 17:49
                // moment().format('LTS');  // 17:49:50
                // moment().format('L');    // 25/06/2021
                // moment().format('l');    // 25/6/2021
                // moment().format('LL');   // 25 giugno 2021
                // moment().format('ll');   // 25 giu 2021
                // moment().format('LLL');  // 25 giugno 2021 17:49
                // moment().format('lll');  // 25 giu 2021 17:49
                // moment().format('LLLL'); // venerdì 25 giugno 2021 17:49
                // moment().format('llll'); // ven 25 giu 2021 17:50

            }
            catch { }
        }

        return result;
    }

    static CapitalizeString(value: string) {
        if (value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
        return value;
    }

    static GetInizialiFromUserName(value: string | undefined) {
        let iniziali = '-';
        if (value) {
            let words = value.split(' ');
            if (words[0])
                iniziali = words[0].slice(0, 1);
            if (words[1])
                iniziali = iniziali + words[1].slice(0, 1);
        }
        return iniziali;
    }

    static GetFileExtension = (filename) => {
        return (filename.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
    }


    static GetBase64WithMimeType(base64String: string, filename: string) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;

        if (base64String.indexOf('base64,') >= 0)
            byteString = base64String.split('base64,')[1];
        else
            byteString = base64String;

        const extension = this.GetFileExtension(filename);

        const MimeTypesMap = {
            png: 'image/png',
            gif: 'image/gif',
            jpg: 'image/jpg',
            jpeg: 'image/jpeg',
            pdf: 'application/pdf',
            mp4: 'video/mp4',
            doc: 'application/msword',
            docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ppt: 'application/vnd.ms-powerpoint',
            xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        };

        //const mimeType = MimeTypesMap[extension];
        const mimeType = MimeTypesMap[extension];

        return `data:${mimeType};base64,${byteString}`;
    }

    static GetMimeType = (fileNameOrExtension: string): string => {
        const extension = fileNameOrExtension?.split('.').pop()?.toLowerCase() || '';

        const mimeTypes: Record<string, string> = {

            ".pdf": "application/pdf",
            ".xml": "application/xml",
            ".p7m": "application/pkcs7-mime",
            ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ".doc": "application/msword",
            ".ppt": 'application/vnd.ms-powerpoint',
            ".xls": "application/vnd.ms-excel",
            ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ".txt": "text/plain",
            ".csv": "text/csv",
            ".zip": "application/zip",
            ".png": "image/png",
            ".jpg": "image/jpeg",
            ".jpeg": "image/jpeg",
            ".gif": "image/gif",
            ".eml": "message/rfc822",
            ".json": "application/json",
            ".md": "text/markdown",
            ".tif": "image/tiff",
            ".tiff": "image/tiff",
        };

        return mimeTypes[extension] || 'application/octet-stream';
    };
    static SaveFileFromBase64(base64String: string, filename: string) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;

        if (base64String.indexOf('base64,') >= 0)
            byteString = base64String.split('base64,')[1];
        else
            byteString = base64String;

        FileSaver.saveAs(`data:application/octet-stream;base64,${byteString}`, filename);


    }

    static SaveFile(fileOrBase64: IFile | string | undefined, fileName?: string): SaveFileResult {
        try {
            if (!fileOrBase64) {
                return { ok: false, reason: 'NoFile', message: 'File non valorizzato.' };
            }

            // Caso A) è una stringa (base64 puro o dataUrl)
            if (typeof fileOrBase64 === 'string') {
                const base64String = fileOrBase64;

                if (!fileName) {
                    return { ok: false, reason: 'MissingFileName', message: 'Nome file mancante.' };
                }

                return this.SaveFileFromBase64StringInternal(base64String, fileName);
            }

            // Caso B) è un IFile
            const file = fileOrBase64;
            const filename = file.fileName;
            if (!filename) {
                return { ok: false, reason: 'MissingFileName', message: 'Nome file mancante.' };
            }

            // 1) Preferisci il File nativo del browser
            if (file.file instanceof File) {
                FileSaver.saveAs(file.file, filename);
                return { ok: true };
            }

            // 2) Fallback base64 da proprietà
            const base64String = file.docBase64String;
            if (!base64String || base64String === 'NotFound') {
                return { ok: false, reason: 'MissingContent', message: 'Contenuto file mancante (né file né docBase64String).' };
            }

            return this.SaveFileFromBase64StringInternal(base64String, filename);
        } catch (e: any) {
            return { ok: false, reason: 'SaveFailed', message: e?.message ?? 'Download non riuscito.' };
        }
    }

    private static SaveFileFromBase64StringInternal(base64String: string, filename: string): SaveFileResult {
        // Supporta:
        // - base64 puro: "JVBERi0x..."
        // - data URL: "data:application/pdf;base64,JVBERi0x..."
        // - eventuali stringhe "sporche" con spazi/newline
        const isDataUrl = base64String.includes('base64,');
        const rawBase64 = (isDataUrl ? base64String.split('base64,')[1] : base64String)?.trim();

        if (!rawBase64 || rawBase64 === 'NotFound') {
            return { ok: false, reason: 'MissingContent', message: 'Base64 mancante.' };
        }

        // validazione minima (evita errori grossolani)
        if (!/^[A-Za-z0-9+/=\r\n]+$/.test(rawBase64)) {
            return { ok: false, reason: 'InvalidBase64', message: 'Base64 non valido.' };
        }

        const mimeType = this.GetMimeType(filename);
        const dataUrl = isDataUrl ? base64String : `data:${mimeType};base64,${rawBase64}`;

        FileSaver.saveAs(dataUrl, filename);
        return { ok: true };
    }

    static downloadFileFromUrl(urlFile: string, fileName: string) {
        axios({
            url: urlFile,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        });

    }

    static Base64StringToBlob(base64String: string, filename: string) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;

        if (base64String.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(base64String.split(',')[1]);
        else
            byteString = unescape(base64String.split(',')[1]);

        const extension = this.GetFileExtension(filename);

        const MimeTypesMap = {
            png: 'image/png',
            gif: 'image/gif',
            jpg: 'image/jpg',
            jpeg: 'image/jpeg',
            pdf: 'application/pdf',
            mp4: 'video/mp4',
            doc: 'application/msword',
            docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ppt: 'application/vnd.ms-powerpoint',
            xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        };

        const mimeType = MimeTypesMap[extension];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeType });
    }

    static OpenNewTabFormBase64String(base64String: string) {
        fetch(base64String)
            .then(res => res.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

                a.href = url;
                a.target = '_blank';
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                URL.revokeObjectURL(url);

            });
    }

    static OpenUrlInNewTab(url) {
        window.open(url, '_blank', 'noopener,noreferrer');
    };


    static GetRegexEmailSingola() {
        const pattern = "^[a-zA-Z0-9.!#$%&'*+\\/?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(?:\\.[a-zA-Z]{2,})$";
        const flags = "m";
        const emailRegex = new RegExp(pattern, flags);
        return emailRegex;
    }
    static GetRegexIndirizziEmailSeparatiDaPuntoEVirgola() {
        const pattern = "[a-zA-Z0-9.!#$%&'*+\\/?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(;|,|\\s|$)?(?:\\.[a-zA-Z]{2,})";
        const flags = "m";
        const emailRegex = new RegExp(pattern, flags);
        return emailRegex;
    }
    static GetGlobalRegexIndirizziEmailSeparatiDaPuntoEVirgola() {
        const pattern = "[a-zA-Z0-9.!#$%&'*+\\/?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(;|,|\\s|$)?(?:\\.[a-zA-Z]{2,})";
        // In JavaScript (e TypeScript), quando una regex ha il flag g, mantiene uno stato interno che memorizza
        // l'ultimo indice di posizione (lastIndex) in cui ha trovato una corrispondenza.
        // Quando esegui la regex di nuovo, inizia la ricerca da quell'indice
        // utile quando devi cercare tutti i risultati all'interno di una stringa
        const flags = "gm";
        const emailRegex = new RegExp(pattern, flags);
        return emailRegex;
    }

    static ReturnEmptyFile(fileName: string = "empty-file",mimeType: string = "application/octet-stream"): File {
        return new File([], fileName, { type: mimeType });
    };
}
